'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
export interface DeleteConfirmModalProps {
  /** 모달 열림 상태 */
  opened: boolean;
  /** 모달 닫기 핸들러 */
  onClose: () => void;
  /** 삭제 확인 핸들러 */
  onConfirm: () => void;
  /** 삭제할 아이템 개수 */
  count?: number;
}
export const DeleteConfirmModal = t0 => {
  const $ = _c(15);
  const {
    opened,
    onClose,
    onConfirm,
    count: t1
  } = t0;
  const count = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== onClose || $[1] !== onConfirm) {
    t2 = () => {
      onConfirm();
      onClose();
    };
    $[0] = onClose;
    $[1] = onConfirm;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleConfirm = t2;
  const t3 = `${count}건의 답례품을 삭제할까요?`;
  let t4;
  if ($[3] !== onClose) {
    t4 = <Button theme="primary-text" dimensions="H48" onClick={onClose} className="flex-1 mobile-tablet:bg-Gray-200 mobile-tablet:text-Gray-black">취소</Button>;
    $[3] = onClose;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== handleConfirm) {
    t5 = <Button dimensions="H48" theme="primary-fill" onClick={handleConfirm} className="flex-1">삭제</Button>;
    $[5] = handleConfirm;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="font-body3 flex w-full flex-col gap-8 mobile-tablet:flex-row">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onClose || $[11] !== opened || $[12] !== t3 || $[13] !== t6) {
    t7 = <Modal opened={opened} onClose={onClose} closeButton={true} header={"\uC0AD\uC81C \uD655\uC778"} description={t3} buttonFooter={t6} />;
    $[10] = onClose;
    $[11] = opened;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};